export default __webpack_public_path__ + "static/macMillan-family-7d7ff41f5bb0694d563006fd3583ae77.jpg";